import classNames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { STEP_IDS } from '../../../store/itinerary/itinerary.constants'
import AddStepButton from './AddStepButton'
import InvertStepsButton from './InvertStepsButton'
import RemoveStepButton from './RemoveStepButton'
import s from './StepsButtons.less'
import { selectStopStepIds } from './steps.selectors'
import { getMaxStops } from './steps.utils'

export function StepsButtons() {
  const stopStepIds = useSelector(selectStopStepIds)
  const displayAddStep = stopStepIds.length < getMaxStops()

  return (
    <>
      <ul>
        <li className={s.item} key="add-step">
          {displayAddStep && <AddStepButton />}
        </li>
        {stopStepIds.map(stepId => (
          <li className={s.item} key={`remove-${stepId}`}>
            <RemoveStepButton stepId={stepId} />
          </li>
        ))}
      </ul>
      <ul className={s.invertButtons}>
        <li className={classNames(s.item)} key="invert-steps">
          <InvertStepsButton stepId={STEP_IDS.departure} />
        </li>
        {stopStepIds.map(stepId => (
          <li className={s.item} key={`invert-${stepId}`}>
            <InvertStepsButton stepId={stepId} />
          </li>
        ))}
      </ul>
    </>
  )
}

export default StepsButtons
